import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { pipelines } from '../Pipelines';

type OptionsType = {
  enabled: boolean;
};

export const usePipelineGraph = () =>
  useQuery({
    queryKey: [QUERY_KEYS.pipelineGraph],
    queryFn: async () => (await pipelines.getGraph()).data,
  });

export const usePipelineLocations = () =>
  useQuery({
    queryKey: [QUERY_KEYS.pipelineLocations],
    queryFn: async () => (await pipelines.getLocations()).data,
  });

export const usePipelines = (locationId?: string, options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.pipeline, locationId],
    queryFn: async () => (await pipelines.getPipelines(locationId)).data,
    enabled: options?.enabled,
  });

export const usePipelineStatus = (locationId?: string, options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.pipeline, locationId],
    queryFn: async () => (await pipelines.getStatuses(locationId)).data,
    enabled: options?.enabled,
  });
